// src/client/lib/queryClient.ts
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      // Borrower devices may sleep for hours mid-session; keep this off so
      // returning to the tab does not flood the network on flaky 3G.
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const code = (error as { code?: string } | null)?.code;
        if (code === 'PGRST301' || code === '42501' || code === 'PGRST302') return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
